import { render } from "./Cabinman.vue?vue&type=template&id=c746f186"
import script from "./Cabinman.vue?vue&type=script&lang=js"
export * from "./Cabinman.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__